import React from 'react';
import { IconProps } from './type';

export const CheckIcon = ({ color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3536 5.14645C12.5488 5.34171 12.5488 5.65829 12.3536 5.85355L7.35355 10.8536C7.15829 11.0488 6.84171 11.0488 6.64645 10.8536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645C4.34171 7.45118 4.65829 7.45118 4.85355 7.64645L7 9.79289L11.6464 5.14645C11.8417 4.95118 12.1583 4.95118 12.3536 5.14645Z"
        fill={color}
      />
    </svg>
  );
};
